import { createPinia } from 'pinia'

const pinia = createPinia()

export default pinia

export * from './modules/user'
export * from './modules/skills'
export * from './modules/app'
export * from './modules/usage'
